import { render } from "./CompPropDetail.vue?vue&type=template&id=2c21662e&scoped=true"
import script from "./CompPropDetail.vue?vue&type=script&lang=js"
export * from "./CompPropDetail.vue?vue&type=script&lang=js"

import "./CompPropDetail.vue?vue&type=style&index=0&id=2c21662e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c21662e"]])

export default __exports__